import { useCallback } from 'react';
import { getErrorMessage } from 'utils/gql/errors/errorsUtils';
import { useSnackbar } from 'src/utils/hooks/useSnackbar';
import { ApolloError } from '@apollo/client';
import { GraphQLError, GraphQLFormattedError } from 'graphql';

export function useApolloErrorSnackbar() {
  const { showError } = useSnackbar();

  return useCallback(
    (error: ApolloError | GraphQLError | GraphQLFormattedError<Record<string, any>> | undefined) => {
      showError(getErrorMessage(error).message);
    },
    [showError]
  );
}
